import { render, staticRenderFns } from "./MnpNonCelcom.vue?vue&type=template&id=74b9de56&"
import script from "./MnpNonCelcom.vue?vue&type=script&lang=js&"
export * from "./MnpNonCelcom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports